<div ngbDropdown>
  <div
    class="input-group-text text-ink-lighter rounded-start bg-white"
    ngbDropdownToggle>
    <div
      class="col ms-0 ps-0 py-2 align-items-start d-flex"
      type="button">
      <span
        class="bg-light-gray"
        id="dropdownLanguage">
        <img
          ngSrc="flags/{{ viewModel().selectedLanguage?.flagIconName }}"
          [width]="flagSize"
          [height]="flagSize"
          [alt]="viewModel().selectedLanguage?.name" />
        <span class="ms-4">{{ viewModel().selectedLanguage?.name | translate }}</span>
      </span>
    </div>
  </div>
  <div
    ngbDropdownMenu
    aria-labelledby="dropdownLanguage"
    class="bg-white w-100">
    @for (item of viewModel().availableLanguageWithNameAndIcons; track item.name) {
      <button
        ngbDropdownItem
        (click)="selectLanguage(item)">
        <img
          [width]="flagSize"
          [height]="flagSize"
          ngSrc="flags/{{ item.flagIconName }}"
          class="me-4"
          [alt]="item.name" />
        {{ item.name | translate }}
      </button>
    }
  </div>
</div>
